<template >
  <b-row>
    <b-col lg="6" style="height: 500px; overflow: auto">
      <h3>{{ $t("teachers.teachers") }}</h3>
      <hr />
      <b-list-group>
        <b-list-group-item
          class="d-flex"
          v-for="teacher in teachers"
          :key="teacher.id"
          button
          :active="teacher.id == teacherSelected.id"
          @click="seleteCourse(teacher)"
        >
          <span class="mr-1">
            <b-form-checkbox
              v-model="eduProgramTeachers"
              :value="teacher.id"
              @change="seleteCourse(teacher)"
              class="custom-control-primary"
            >
            </b-form-checkbox>
          </span>
          <span>{{ teacher.full_name }}</span>
        </b-list-group-item>
      </b-list-group>
      <b-spinner v-if="load" type="grow" label="Loading..."  class="loading" />
    </b-col>
    <b-col lg="6">
      <h3>{{ $t("edu_courses.edu_courses") }}</h3>
      <hr />
      <b-list-group v-show="showCourses">
        <b-list-group-item
          class="d-flex"
          v-for="course in courses"
          :key="course.id"
          button
          @change="changeCourses(course)"
        >
          <span class="mr-1">
            <b-form-checkbox
              v-model="courseSelected"
              :value="course.id"
              class="custom-control-primary"
            >
            </b-form-checkbox>
          </span>
          <span>{{ course.code }}-{{ course.name }}</span>
        </b-list-group-item>
      </b-list-group>
    </b-col>
    <hr />

    <b-col lg="6">
      <b-button block variant="primary" @click="submit()">
        <i class="fa fa-plus" /> {{ $t("site.save") }}
      </b-button>
    </b-col>
    <b-col lg="6">
      <b-button block @click="goToTable()" variant="success">
        <i class="fas fa-ban"></i> {{ $t("site.cancel") }}
      </b-button>
    </b-col>
  </b-row>
</template>

<script>
import UsersController from "@/Controllers/UsersController";
import EduProgramsController from "@/Controllers/EduProgramsController";
let eduCTR = new EduProgramsController();
export default {
  props: ["eduProgram"],

  data() {
    return {
      teachers: [],
      eduProgramTeachers: [],
      courses: [],
      showCourses: false,
      teachersCourses: [],
      courseSelected: [],
      teacherSelected: {},
      load: false,
      eduProgramId: this.$route.params.eduProgramId,
      semster_id : null
    };
  },
  created() {
    this.getData();
    //get semster_id 
    let semster_id = eduCTR.getSemsterId(this.$route.params.eduProgramId);
    semster_id.then((res) => {
      this.semster_id = res.id;
    });
  },
  methods: {
    seleteCourse(teacher) {
      this.teacherSelected = teacher;
      this.showCourses = false;
      // console.log(this.eduProgramTeachers.indexOf(teacher.id) != -1);
      this.courseSelected = [];
      // if (this.eduProgramTeachers.indexOf(teacher.id) != -1)
      this.showCourses = true;

      const teachersCourse = this.teachersCourses.filter(
        (a) => a.teacher_id == teacher.id
      );
      this.courseSelected = teachersCourse.map((item) => item.course_id);
    },

    changeCourses(course) {
      const index = this.teachersCourses.findIndex(
        (a) =>
          a.course_id == course.id && a.teacher_id == this.teacherSelected.id
      );
      if (index != -1) this.teachersCourses.splice(index, 1);
      else
        this.teachersCourses.push({
          teacher_id: this.teacherSelected.id,
          course_id: course.id,
          edu_program_id: this.eduProgramId,
          semster_id: this.semster_id,
        });
    },
    async returnData() {},
    async getData(id) {
      this.load = true;
      new UsersController().GetAll({ type: "teacher" }).then((res) => {
        this.teachers = res;
        this.load = false;
      });
      if (id) {
        this.eduProgramId = id;
      }
      if (this.eduProgramId) {
        // eduCTR.GetUsers(this.eduProgramId).then((user) => {
        //   this.eduProgramTeachers = user.teachers.map((item) => item.id);
        // });
        eduCTR.GetTeachersCourses(this.eduProgramId).then((res) => {
          this.teachersCourses = res;
          this.eduProgramTeachers = res.map((item) => item.teacher_id);
        });
        eduCTR.getCourseByProgramTeacher(this.eduProgramId).then((res) => {
          this.courses = res.filter((a) => a.flixable == 0);
        });
      }
    },
    goToTable() {
      this.$parent.$parent.$children[0].$children[0].$refs.table.refresh();
      this.$parent.$parent.firstTab();
    },
    async submit() {
      const data = [];
      // console.log(this.teachersCourses);

      // this.teachersCourses.forEach((element) => {});
      for (const [key, value] of Object.entries(this.teachersCourses)) {
        console.log(value);
        data.push({ teacherId: key, courses: value });
      }

      eduCTR.SaveTeachers(this.eduProgramId, {
        data,
      });
    },
  },
};
</script>

<style>
</style>